export type NetworkType =
    | 'unknown'
    | 'none'
    | 'wifi'
    | '4g'
    | '3g'
    | '2g'
    | undefined;

enum PVStateType {
    enter = 'enter',
    leave = 'leave',
    visible = 'visible',
    hidden = 'hidden',
}

export enum LogTypeEnum {
    // 曝光
    show = 'SHOW',
    // 点击
    click = 'CLICK',
    // PV
    pv = 'PV',
    // 雷达事件或webLogger的定义事件，如果需要实时性就用radar，t+1统计用weblogger
    custom = 'CUSTOM',
    task = 'BACKGROUND_TASK_EVENT',
}

export interface LogData {
    type: keyof typeof LogTypeEnum;
    stateType?: keyof typeof PVStateType;
    name?: string;
    value?: Record<string, any>;
    eventId?: string;
    auto?: boolean;
    beginTime?: number;
    urlPage?: Record<string, any> | null;
}
